export const invoicecCardInfo = {
	title: "Datos de la factura fiscal",
	billNumber: "Número de la factura",
	noteSeries: "Serie de la factura",
	noteData: "Fecha de la factura",
	CFOP: "CFOP",
	accesskey: "Clave de acceso",
	natureOfOperation: "Naturaleza de la operación",
	issuer: "Emisor",
	CNPJAndCPF: "RFC",
	amount: "Valor total",
};
